import { render } from "./SelectLanguage.vue?vue&type=template&id=a0447a92&scoped=true&ts=true"
import script from "./SelectLanguage.vue?vue&type=script&lang=ts"
export * from "./SelectLanguage.vue?vue&type=script&lang=ts"

import "./SelectLanguage.vue?vue&type=style&index=0&id=a0447a92&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./SelectLanguage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0447a92"]])

export default __exports__